/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, ElementRef, Host, Input, Optional, Renderer2 } from "@angular/core";
import { NzColDirective } from "ng-zorro-antd/grid";
import { GridEmbeddedProperty } from "@webapp/ui/grid/grid.models";
import { UiRowDirective } from "@webapp/ui/grid/row.directive";
import { Directionality } from "@angular/cdk/bidi";

@Directive({
  selector: "[ui-col],ui-col,ui-form-control,ui-form-label",
  exportAs: "uiCol",
  host: {
    "[style.flex]": "hostFlexStyle",
  },
})
export class UiColDirective extends NzColDirective {
  @Input("colFlex") nzFlex: string | number | null = null;
  @Input("colSpan") nzSpan: string | number | null = null;
  @Input("colOrder") nzOrder: string | number | null = null;
  @Input("colOffset") nzOffset: string | number | null = null;
  @Input("colPush") nzPush: string | number | null = null;
  @Input("colPull") nzPull: string | number | null = null;
  @Input("colXs") nzXs: string | number | GridEmbeddedProperty | null = null;
  @Input("colSm") nzSm: string | number | GridEmbeddedProperty | null = null;
  @Input("colMd") nzMd: string | number | GridEmbeddedProperty | null = null;
  @Input("colLg") nzLg: string | number | GridEmbeddedProperty | null = null;
  @Input("colXl") nzXl: string | number | GridEmbeddedProperty | null = null;
  @Input("colXXl") nzXXl: string | number | GridEmbeddedProperty | null = null;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(elementRef: ElementRef, @Optional() @Host() nzRowDirective: UiRowDirective, renderer: Renderer2, @Optional() directionality: Directionality) {
    super(elementRef, nzRowDirective, renderer, directionality);
  }
}
